import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-customs-tarif',
  templateUrl: './customs-tarif.component.html',
  styleUrls: ['./customs-tarif.component.css']
})
export class CustomsTarifComponent implements OnInit {
    public customsTarifId: string;

    public edit?: Edit;

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.customsTarifId = this.stateService.getStateParams()['customstarif_id'];
    }

    private async loadEdit() {
        if (!!this.customsTarifId) {
            this.edit = (await this.datatask.Post(1727, { customstarif_id: this.customsTarifId }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(1728, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    customstarif_id: string;
    customstarif_name: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('customsTarif', {
//        templateUrl: 'views/components/views/customsTarif/customsTarif.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'modalService', 'translateService', 'customsTarifService', function ($stateParams, stateService, modalService, translateService, customsTarifService) {
//            const vm = this;
//            let customsTarifId = $stateParams.customstarif_id;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                customsTarifId: customsTarifId,
//                edit: {},
//                lockedSave: false
//            };

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            async function loadEdit() {
//                vm.model.edit = (await customsTarifService.getTarif({ customstarif_id: customsTarifId }))[0];
//            }

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                customsTarifService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            }

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//            }
//        }]
//    });
//})();
